export default __webpack_public_path__ + "static/media/car16.196285ae.jpg";